<template>
   <conponent :is="icon"/>    
</template>

<script>
export default {
  props: ["type"],
  computed: {
    icon() {
      const v = this.type == 'success' ? 'SuccessGraph' : 'LossGraph';
      return () => import(`./${v}.vue`);
    },
  },
};
</script>

<style lang="scss" scoped></style>
